import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Maximize2, ArrowLeft, X } from 'lucide-react';
import ProdutividadeComponent from '../Dashboard/Produtividade'; // ajuste o caminho
import OrderStatusComponent from '../Dashboard/OrderStatusComponent';

function Produtividade() {
    const navigate = useNavigate();
    const [isFullscreen, setIsFullscreen] = useState(false);

    const handleFullscreen = async () => {
        try {
            const elem = document.documentElement;
            if (!isFullscreen) {
                if (elem.requestFullscreen) {
                    await elem.requestFullscreen();
                } else if (elem.webkitRequestFullscreen) {
                    await elem.webkitRequestFullscreen();
                } else if (elem.mozRequestFullScreen) {
                    await elem.mozRequestFullScreen();
                }
                setIsFullscreen(true);
            } else {
                if (document.exitFullscreen) {
                    await document.exitFullscreen();
                } else if (document.webkitExitFullscreen) {
                    await document.webkitExitFullscreen();
                } else if (document.mozCancelFullScreen) {
                    await document.mozCancelFullScreen();
                }
                setIsFullscreen(false);
            }
        } catch (err) {
            console.error('Erro ao alternar tela cheia:', err);
        }
    };

    const handleVoltar = () => {
        if (isFullscreen) {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            }
            setIsFullscreen(false);
        }
        navigate(-1);
    };

    return (
        <div style={{ minHeight: '100vh', backgroundColor: '#f5f5f5' }}>
            {/* Header com botões */}
            <div
                style={{
                    backgroundColor: 'white',
                    padding: '1rem 2rem',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    borderBottom: '1px solid #e0e0e0',
                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
                    zIndex: 1000,
                    position: 'sticky',
                    top: 0
                }}
            >
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                    <button
                        onClick={handleVoltar}
                        style={{
                            backgroundColor: '#ff6b6b',
                            border: 'none',
                            color: 'white',
                            padding: '0.7rem 1.2rem',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            fontSize: '0.9rem',
                            fontWeight: '600',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.5rem',
                            transition: 'all 0.2s ease',
                            boxShadow: '0 2px 4px rgba(255, 107, 107, 0.3)'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = '#fa5252';
                            e.currentTarget.style.transform = 'translateY(-2px)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = '#ff6b6b';
                            e.currentTarget.style.transform = 'translateY(0)';
                        }}
                    >
                        <ArrowLeft size={18} />
                        Voltar
                    </button>
                    <h1 style={{ margin: 0, fontSize: '1.8rem', fontWeight: '700', color: '#212529' }}>
                        Produtividade
                    </h1>
                </div>

                <button
                    onClick={handleFullscreen}
                    style={{
                        backgroundColor: isFullscreen ? '#339af0' : '#51cf66',
                        border: 'none',
                        color: 'white',
                        padding: '0.7rem 1.2rem',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        fontSize: '0.9rem',
                        fontWeight: '600',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                        transition: 'all 0.2s ease',
                        boxShadow: isFullscreen
                            ? '0 2px 4px rgba(51, 154, 240, 0.3)'
                            : '0 2px 4px rgba(81, 207, 102, 0.3)'
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-2px)';
                        if (isFullscreen) {
                            e.currentTarget.style.backgroundColor = '#1c7ed6';
                        } else {
                            e.currentTarget.style.backgroundColor = '#40c057';
                        }
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.backgroundColor = isFullscreen ? '#339af0' : '#51cf66';
                    }}
                >
                    {isFullscreen ? (
                        <>
                            <X size={18} />
                            Sair Tela Cheia
                        </>
                    ) : (
                        <>
                            <Maximize2 size={18} />
                            Tela Cheia
                        </>
                    )}
                </button>
            </div>

            {/* Conteúdo */}
            <div style={{ padding: '2rem' }}>
                {/* <OrderStatusComponent /> */}
                <div style={{ marginTop: '2rem' }}>
                    <ProdutividadeComponent />
                </div>
            </div>
        </div>
    );
}

export default Produtividade;